<template>
  <div class="detect-report-page">
    <div v-if="loading" class="loading">加载报告中…</div>
    <div v-else-if="errorMessage" class="error">{{ errorMessage }}</div>
    <DetectReport v-else :detail="detail" :loading="false" @refresh="loadDetail" />
  </div>
</template>

<script>
import DetectReport from '@/components/detect/DetectReport.vue'
import { getDetectTaskDetail } from '@/api/portal/detect'

export default {
  name: 'DetectReportPage',
  components: { DetectReport },
  data() {
    return {
      loading: true,
      errorMessage: '',
      detail: {}
    }
  },
  watch: {
    '$route.query.taskId': {
      immediate: true,
      handler() {
        this.loadDetail()
      }
    }
  },
  methods: {
    loadDetail() {
      const taskId = this.$route.query.taskId
      if (!taskId) {
        this.errorMessage = '缺少任务编号'
        this.loading = false
        return
      }
      this.loading = true
      this.errorMessage = ''
      getDetectTaskDetail(taskId)
          .then(res => {
            this.detail = res.data || {}
            if (this.detail.status !== '2') {
              this.errorMessage = this.detail.status === '3'
                  ? (this.detail.errorMsg || '检测失败')
                  : '检测尚未完成'
            }
          })
          .catch(err => {
            this.errorMessage = err.message || '加载失败'
          })
          .finally(() => {
            this.loading = false
          })
    }
  }
}
</script>

<style scoped>
.detect-report-page {
  max-width: 960px;
  margin: 0 auto;
  padding: 8px 0 32px;
}

.loading,
.error {
  padding: 40px;
  text-align: center;
  color: #6b7280;
  font-size: 15px;
}

.error {
  color: #b91c1c;
}
</style>
